// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_da0c6c', '__Inter_Fallback_da0c6c'","fontStyle":"normal"},"className":"__className_da0c6c","variable":"__variable_da0c6c"};